import React from "react";
import { Button } from 'antd';
import { PATHS } from "@config/constants";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UserLogin = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const handleClick = _ => {
    history.push(PATHS.LOGIN_PAGE);
  };

  return (
    <div className="user-login">
      <Button type="primary" className="user-login-button" onClick={handleClick}>
        {t("login.form.btnLogin")}
      </Button>
    </div>
  );
};

export default UserLogin;
